import React from 'react';
import { LinkProps } from 'react-router-dom';

import HrefLink, { IProps } from './HrefLink';

type NoOpenerLinkProps = IProps & Omit<Partial<LinkProps>, 'target' | 'rel'>;

const NoOpenerLink = ({ active = true, ...rest }: NoOpenerLinkProps) => {
  return (
    <HrefLink
      active={active}
      {...rest}
      target="_blank"
      rel="noopener noreferrer"
    />
  );
};

export default NoOpenerLink;
